import React, {useEffect, useState} from 'react'
import { useStore, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import Header from '../../components/header'
import { useIntl } from 'react-intl'
import { Iconfont } from '../../components/icon/iconfont'
import sourceOnlyClick from '../../hocs/source-only-click'
import { action_fetch_message, action_fetch_ticket_questions } from '../../../store/actions/pages/customer'
import { useApp, useQuery } from '../../hooks/common'
import { facebookSdkInit } from './components/sdk-init'

const EntryButton = sourceOnlyClick(props => {
    useStyles(classes);
    const {item, linkTo, sensors, innerRef} = props

    return (
        <div ref={innerRef}
             className={classes.EntryButton}
             onClick={() => linkTo(item?.to, item?.question)}
             data-type={sensors?.resource_type}
             data-title={sensors?.resourcepage_title}
             data-content={sensors?.resource_content}
             >
            <Iconfont className={classes.EntryIcon} dangerouslySetInnerHTML={{__html: item?.icon}}></Iconfont>
            <span>{item?.question}</span>
        </div>
    )
})

const EntryButtonBox = props => {
    useStyles(classes);
    const {buttonList,linkTo} = props
    return (
        <div className={classes.EntryButtonBox}>
            {
                buttonList?.map((item, index) => (
                    <EntryButton
                        key={index}
                        item={item}
                        linkTo={(url, txt) => linkTo(url, txt)}
                        sensors={{
                            resourcepage_title: 'support',
                            resource_content: item?.content,
                            resource_type: 'supportClick',
                        }}
                        />
                ))
            }
        </div>
    )
}

const SupportButtons = sourceOnlyClick(props => {
    useStyles(classes);
    const {intl, history, BASE_ME, newsTip, innerRef, toContact} = props

    return (
        <div className={classes.SupportButtons}>
            <div className={classes.ClickToFAQ}>
                {intl.formatMessage({id:"click"})}
                <span onClick={()=>history.push({pathname: `${BASE_ME}/support/faq`})}>{intl.formatMessage({id:"faq"})}</span> 
                {intl.formatMessage({id:"page"})} 
            </div>

            <div className={classes.FindMore}>
                {intl.formatMessage({id:"find_nothing"})}
            </div>

            <div className={classes.ContactUs}
                ref={innerRef}
                onClick={()=>toContact()}
                data-title={'ContactUs'}
                data-content={'contactUs'}
                data-type={'contactUsClick'}
                data-source
                data-source-click
                >
                <Iconfont className={classes.ContactIcon}>&#xe6e9;</Iconfont>
                {intl.formatMessage({id:"contact_us"})}
            </div>

            {
                newsTip &&
                <div className={classes.TipText}>
                    {newsTip}
                </div>
            }
        </div>
    )
})

const SupportPage = props => {
    useStyles(classes);
    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const { customer, message, ticketQuestions } = useSelector(state => state.pageCustomer);
    const global = useSelector((state) => state.global);
    const { config } = global;
    const { appId, pageId, messengerAppId } = config?.facebook || {};
    const [loading, setLoading] = useState(false);
    const Intl = useIntl()
    const history = useHistory()
    const [newsTip, setNewsTip] = useState('')
    const [markup, setMarkup] = useState(null)
    const isApp = useApp()
    const BASE_ME = '/user'
    let uniqId = `${customer?.id}_${new Date().getTime()}`
    const [buttonList, setButtonList] = useState([])

    useEffect(async () => {
        if(window.zE){
            window.zE('webWidget', 'hide');
        }
        // document.body.style.background = "#fff"
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
            if(!ticketQuestions){
                await SupportPage.fetchData(store, params, query)
            }
		}
        return (() => {
            // document.body.style.background = ''
        })
    }, [])

    useEffect(() => {
        if(config?.facebook){
            facebookSdkInit({messengerAppId: messengerAppId, userId:customer?.id, pageId:pageId, appId:appId, uniqId:uniqId})
            setMarkup(`
                <div class="fb-messenger-checkbox"
                     origin="${global?.config?.root}"
                     messenger_app_id="${messengerAppId}"
                     page_id="${pageId}"
                     user_ref="${uniqId}"
                     size="standard"
                     allow_login="true"
                     center_align="${true}" skin="light"></div>`);
        }
    }, [config])

    useEffect(() => {
        if(message?.['M1645']){
            setNewsTip(message['M1645'])
        }
    }, [message])

    useEffect(() => {
        if(ticketQuestions){
            let list = ticketQuestions.map((item) => {
                return {...item, to:`${BASE_ME}/support/faq`}
            })
            setButtonList(list)
        }
    }, [ticketQuestions])

    const linkTo = (url, txt) => {
        history.push({pathname:url, params:{title:txt}})
    }

    const toContact = () => {
        if(!customer?.id){
            if(isApp){
                window.location.href = "chic-me://chic.me/loginRoot"
            } else {
                // window.location.href = `/i/login?redirectUrl=${encodeURIComponent('/support/contact-us')}`
                history.push(`/i/login?redirectUrl=${encodeURIComponent('/support/contact-us')}`)
            }
        } else {
            history.push(`/user/support/contact-us`)
            // window.location.href = `${BASE_ME}/support/contact-us`
        }
    }

    return <div className={classes.SupportPage}>
        {/* Intl.formatMessage({ id: "support", defaultMessage: "Support" }) */}
        <Header centerSlot={Intl.formatMessage({ id: "support", defaultMessage: "Support" })}/>

        <EntryButtonBox buttonList={buttonList} linkTo={(url, txt) => linkTo(url, txt)}/>

        <SupportButtons
            intl={Intl}
            history={history}
            BASE_ME={BASE_ME}
            newsTip={newsTip}
            toContact={() => toContact()}
            />

        {
            customer?.id && !customer?.subscribeToFacebookMessage ?
            <div className={classes.FBBox}>
                <div id="fmsg" style={{ color: newsTip?'#222':'rgb(230,69,69)'}}>
                    {Intl.formatMessage({ id: 'facebook_check' })}
                </div>
                {/* <div className="fb-messenger-checkbox"
                    target="_top"
                    origin={global?.__FB_Origin}
                    page_id={window?.__FB_Page_ID}
                    messenger_app_id={window?.__FB_Messenger_App_ID}
                    user_ref={window?.__FB_User_Ref}
                    size="small"
                    skin="light"
                    center_align="true"
                    >
                </div> */}
                <div className={classes.FBBCheckBox} dangerouslySetInnerHTML={{__html: markup}}></div>
                {/* <SendToMessagener customerId={customer?.id}/> */}
            </div>:
            <React.Fragment></React.Fragment>
        }
    </div>
}


SupportPage.fetchData = async (store, params, search, headers) => {
    const getMessage = store.dispatch(action_fetch_message('M1645',headers))
    const getQuestions = store.dispatch(action_fetch_ticket_questions(headers))
    return await Promise.all([getMessage,getQuestions])
}

export default SupportPage